<ng-container *ngIf="multiple">
    <ng-container *ngIf="!readonly; else readonlyOut" class="reset">
        <ng-container *ngIf="canFilter; else noMultipleFields">
            <mat-form-field *ngIf="!readonly; " class="selectOPT" appearance="outline">
                <mat-label style="text-transform: capitalize;" *ngIf="label">{{ 'common.selectLabel' | translate: { label: label | translate } }} </mat-label>

                <button type="button" [attr.aria-label]="'common.selectAll' | translate" class="btn_" (click)="selectAllFiltered(selectRef)" [matTooltip]="'common.selectAll' | translate" matPrefix [disableRipple]="true"
                    mat-icon-button>
                    <mat-icon
                        [color]=" value?.length == itemsMemory.length ? 'primary' : value?.length > 0 ? 'accent' : 'warn' ">check_circle</mat-icon>
                </button>

                <mat-select panelClass="default-select-panel" disableRipple (openedChange)="isOpenBro($event)" [(ngModel)]="value"
                    [disabled]="(!itemsMemory || itemsMemory.length == 0) || disabled" #selectRef multiple
                    [compareWith]="compareEntity">



                    <mat-option class="p-0">
                        <div class="d-flex flex-row justify-content-between w-100 custom__">

                            <div class="d-flex align-items-center">
                                <button type="button" [attr.aria-label]="'common.selectSearched' | translate" matPrefix (click)="selectAllFiltered(selectRef)" [disableRipple]="true"
                                    mat-icon-button [matTooltip]="'common.selectSearched' | translate"
                                    class="d-flex gap-1 justify-content-between base_ w-100 ">
                                    <mat-icon
                                        [color]="value?.length == itemsMemory.length ? 'primary' : value?.length > 0 ? 'accent' : 'warn' ">check_circle</mat-icon>
                                </button>
                            </div>

                            <div class="d-flex align-items-center custom__search">
                                <ngx-mat-select-search [disableInitialFocus]="true" #valueNgxSelectSearch (paste)="pasteValue($event);" [hideClearSearchButton]="true" ngModel
                                    [placeholderLabel]="'common.searchLabel' | translate: { label: label | translate }" style="position: relative;"
                                    [noEntriesFoundLabel]="'common.noResults' | translate"></ngx-mat-select-search>
                            </div>

                            <div class="d-flex align-items-center" [matTooltip]="'common.deselectSearched' | translate">
                                <button type="button" [attr.aria-label]="'common.deselectSearched' | translate" (click)="deselectAllFiltered(selectRef)" [disableRipple]="true"
                                    mat-icon-button
                                    [disabled]="!hasFilteredSelection()"
                                    class="d-flex gap-1 justify-content-between base_ w-100 ">
                                    <mat-icon>clear</mat-icon>
                                </button>
                            </div>

                        </div>
                    </mat-option>


                    <mat-option *ngFor="let item of itemsMemory" [value]="item">
                        <div class="item_cont__">
                            <span>{{showValue(item)}}</span>
                          <ng-container *ngIf="source === 'expansion'">
                            <app-column-icon-field-select [item]="item" [brandId]="item.brandId">
                            </app-column-icon-field-select>
                          </ng-container>
                        </div>
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="value?.length > 1 && !hideHint">
                    ({{value?.length }} {{ 'order.total' | translate}})
                </mat-hint>


                <button type="button" [attr.aria-label]="'common.deselectAll' | translate" mat-icon-button matSuffix [matTooltip]="'common.deselectAll' | translate"
                    style="pointer-events: auto"
                    [disabled]="!value?.length" (click)="clearValues(); $event.preventDefault()">
                    <mat-icon>
                        clear
                    </mat-icon>
                </button>


            </mat-form-field>
        </ng-container>

        <ng-template #noMultipleFields>

            <ng-container *ngIf="canFilter; else nowr">

                <mat-form-field *ngIf="!readonly; " class="selectOPT" appearance="outline">
                    <mat-label style="text-transform: capitalize;" *ngIf="label">
                        {{ 'common.selectLabel' | translate: { label: label | translate } }}
                    </mat-label>

                    <button type="button" [attr.aria-label]="'common.selectAll' | translate" (click)="selectAllFiltered(selectRefOp)" [matTooltip]="'common.selectAll' | translate"
                        *ngIf="!disabledItemAllButton" matPrefix [disableRipple]="true" mat-icon-button>
                        <mat-icon
                            [color]="value?.length == itemsMemory.length ? 'primary' : value?.length > 0 ? 'accent' : 'warn' ">check_circle</mat-icon>
                    </button>

                    <mat-select panelClass="default-select-panel" [required]="isRequiredVal" (openedChange)="isOpenBro($event)" [(ngModel)]="value"
                        [disabled]="(!itemsMemory || itemsMemory.length == 0) ||disabled" #selectRefOp multiple
                        [compareWith]="compareEntity">

                        <mat-option class="p-0">
                            <div class="d-flex flex-row justify-content-between w-100 custom__">

                                <div class="d-flex align-items-center">
                                    <button type="button" [attr.aria-label]="'common.selectSearched' | translate" matPrefix (click)="selectAllFiltered(selectRefOp)" [disableRipple]="true"
                                        mat-icon-button [matTooltip]="'common.selectSearched' | translate"
                                        class="d-flex gap-1 justify-content-between base_ w-100 ">
                                        <mat-icon
                                            [color]="value?.length == itemsMemory.length ? 'primary' : value?.length > 0 ? 'accent' : 'warn' ">check_circle</mat-icon>
                                    </button>
                                </div>

                                <div class="d-flex align-items-center custom__search">
                                    <ngx-mat-select-search #valueNgxSelectSearch [hideClearSearchButton]="true" ngModel
                                        [placeholderLabel]="'common.searchLabel' | translate: { label: label | translate }" style="position: relative;"
                                        [noEntriesFoundLabel]="'common.noResults' | translate"></ngx-mat-select-search>
                                </div>

                                <div class="d-flex align-items-center" [matTooltip]="'common.deselectSearched' | translate">
                                    <button type="button" [attr.aria-label]="'common.deselectSearched' | translate" (click)="deselectAllFiltered(selectRefOp)" [disableRipple]="true"
                                        mat-icon-button
                                        [disabled]="!hasFilteredSelection()"
                                        class="d-flex gap-1 justify-content-between base_ w-100 ">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </div>

                            </div>
                        </mat-option>



                        <mat-option *ngFor="let item of itemsMemory" [value]="item">
                            {{ showValue(item) }}
                        </mat-option>

                    </mat-select>
                    <mat-hint *ngIf="value?.length > 1 && !hideHint">
                        ({{value?.length }} {{ 'order.total' | translate}})
                    </mat-hint>

                    <button type="button" [attr.aria-label]="'common.deselectAll' | translate" mat-icon-button matSuffix [matTooltip]="'common.deselectAll' | translate"
                        style="pointer-events: auto"
                        [disabled]="disabledClear || !value?.length" (click)="clearValues();">
                        <mat-icon>
                            clear
                        </mat-icon>
                    </button>

                </mat-form-field>

            </ng-container>

            <ng-template #nowr>

                <mat-form-field *ngIf="!readonly; " class="selectOPT" appearance="outline">
                    <mat-label style="text-transform: capitalize;" *ngIf="label">
                        {{ 'common.selectLabel' | translate: { label: label | translate } }}
                    </mat-label>

                    <button type="button" [attr.aria-label]="'common.selectAll' | translate" (click)="selectAllFiltered(selectRefOp)" [matTooltip]="'common.selectAll' | translate"
                        *ngIf="!disabledItemAllButton" matPrefix [disableRipple]="true" mat-icon-button>
                        <mat-icon
                            [color]="value?.length == itemsMemory.length ? 'primary' : value?.length > 0 ? 'accent' : 'warn' ">check_circle</mat-icon>
                    </button>

                    <mat-select [required]="isRequiredVal" [(ngModel)]="value"
                        [disabled]="(!itemsMemory || itemsMemory.length == 0) ||disabled" #selectRefOp multiple
                        [compareWith]="compareEntity">



                        <mat-option *ngFor="let item of itemsMemory" [value]="item">
                            {{ showValue(item) }}
                        </mat-option>

                    </mat-select>
                    <mat-hint *ngIf="value?.length > 1 && !hideHint">
                        ({{value?.length }} {{ 'order.total' | translate}})
                    </mat-hint>

                    <button type="button" [attr.aria-label]="'common.deselectAll' | translate" mat-icon-button matSuffix [matTooltip]="'common.deselectAll' | translate"
                        style="pointer-events: auto"
                        [disabled]="disabledClear || !value?.length" (click)="clearValues();">
                        <mat-icon>
                            clear
                        </mat-icon>
                    </button>

                </mat-form-field>

            </ng-template>

        </ng-template>




    </ng-container>
</ng-container>



<ng-container *ngIf="!multiple">
    <ng-container *ngIf="!readonly; else readonlyOut">
        <mat-form-field class="selectOPT" appearance="outline">
            <mat-label style="text-transform: capitalize;" *ngIf="label">{{ 'common.selectLabel' | translate: { label: label | translate } }}</mat-label>
            <!-- settleClosedPicks: a CLOSED single mat-select selects on every arrow key, so a host whose
                 change does work (a search) holds those picks until blur or close; see ClosedSelectPick. -->
            <mat-select [compareWith]="compareEntity" [disabled]="disabled" [ngModel]="value"
                (ngModelChange)="onSingleModelChange($event)"
                [appSettleClosedPick]="settleClosedPicks ? singlePick : null">
                <mat-option *ngFor="let item of itemsMemory" [value]="item">
                    {{showValue(item)}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>
</ng-container>

<ng-template #readonlyOut>
    <mat-form-field class="selectOPT" appearance="outline">
        <mat-label style="text-transform: capitalize;" *ngIf="label">{{ 'common.selectLabel' | translate: { label: label | translate } }}</mat-label>
        <input [readonly]="true" matInput type="text" value="{{showValue(value)}}">
    </mat-form-field>
</ng-template>
